// https://hoangtrinhj.com/using-google-analytics-with-next-js

export const GTM_ID = 'GTM-WLS9CNQ';
export const GA_TRACKING_ID = 'G-3W8KH4GD7S';

export type GA_CATEGORY =
  | 'docs'
  | 'landing-page'
  | 'docs-search'
  | 'docs-live-ui'
  | 'engagement';

export type GA_ACTION =
  | 'click'
  | 'signup'
  | 'login'
  | 'search'
  | 'select-project'
  | 'select-client'
  | 'select-secret'
  | 'get-token-started'
  | 'get-token-response-received'
  | 'execute';

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = (url: string): void => {
  window.gtag('config', GA_TRACKING_ID, {
    page_path: url,
  });
};

export interface AnalyticsEvent {
  action: GA_ACTION;
  category: GA_CATEGORY;
  label: string;
  value?: number;
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const event = ({
  action,
  category,
  label,
  value,
}: AnalyticsEvent): void => {
  // console.log({ action, category, label, value });
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value,
  });
};

// called from the various "try it now" buttons
export const tryButtonClick = (tryButtonId: string): void => {
  event({
    category: 'engagement',
    action: 'signup',
    label: tryButtonId,
  });
};
